import { render, staticRenderFns } from "./SalesTopRecordCustomer.vue?vue&type=template&id=30b76177"
import script from "./SalesTopRecordCustomer.vue?vue&type=script&lang=js"
export * from "./SalesTopRecordCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports